export class Sequence {
    id?: number;
    code: string = '';
    current: number = 0;
    prefix:string = '';
    suffix: string = '';
    fill: number = 5;
    rectificative_code: string = '';
    rectificative_current: number = 0;
    rectificative_prefix: string = '';
    rectificative_suffix: string = '';
    rectificative_fill: number = 5;
    is_for_recurring_contracts: boolean = false;
    company_id?: number;
    next_number?: string;
    next_rectificative_number?: string;
    min_number?: number;
    min_inv_date?: string;
    min_rectificative_number?: number;
    min_rectificative_inv_date?: string;

    constructor(
        id?: number,
        code: string = '',
        current: number = 0,
        prefix: string = '',
        suffix: string = '',
        fill: number = 5,
        rectificative_code: string = '',
        rectificative_current: number = 0,
        rectificative_prefix: string = '',
        rectificative_suffix: string = '',
        rectificative_fill: number = 5,
        is_for_recurring_contracts: boolean = false,
        company_id?: number,
        next_number?: string,
        next_rectificative_number?: string,
        min_number?: number,
        min_inv_date?: string,
        min_rectificative_number?: number,
        min_rectificative_inv_date?: string,

    ) {
        this.id = id;
        this.code = code;
        this.current = current;
        this.prefix = prefix;
        this.suffix = suffix;
        this.fill = fill;
        this.rectificative_code = rectificative_code;
        this.rectificative_current = rectificative_current;
        this.rectificative_prefix = rectificative_prefix;
        this.rectificative_suffix = rectificative_suffix;
        this.rectificative_fill = rectificative_fill;
        this.is_for_recurring_contracts = is_for_recurring_contracts;
        this.company_id = company_id;
        this.next_number = next_number;
        this.next_rectificative_number = next_rectificative_number;
        this.min_number = min_number;
        this.min_inv_date = min_inv_date;
        this.min_rectificative_number = min_rectificative_number;
        this.min_rectificative_inv_date = min_rectificative_inv_date;
    }
}